module.exports = __webpack_public_path__ + "img/logopyv.779b4d2f.svg";